import { createSlice } from '@reduxjs/toolkit';
export const recommendationCardSlice = createSlice({
  name: 'recommendationCardSlice',
  initialState: {
    dashboardAccordion: [{
      accordionKey: 'Applications',
      accordionName: ['Application Name', 'Application Type', 'Application Risk Category', 'Application Risk Score']
    }, {
      accordionKey: 'Environment',
      accordionName: ['Environment Name', 'Environment Risk Category', 'Environment Risk Score']
    }, {
      accordionKey: 'Entity',
      accordionName: ['Entity Name', 'Entity Type', 'Entity Risk Category', 'Entity Risk Score']
    }],
    applicationAccordion: [{
      accordionKey: 'Environment',
      accordionName: ['Environment Name', 'Environment Risk Category', 'Environment Risk Score']
    }, {
      accordionKey: 'Entity',
      accordionName: ['Entity Name', 'Entity Type', 'Entity Risk Category', 'Entity Risk Score']
    }],
    envAccordion: [{
      accordionKey: 'Entity',
      accordionName: ['Entity Name', 'Entity Type', 'Entity Risk Category', 'Entity Risk Score']
    }],
    recommendationKeyItems: []
  },
  reducers: {
    pushRecoEntityKeyData: (state, action) => {
      state.recommendationKeyItems = action.payload;
    }
  }
});
export const {
  pushRecoEntityKeyData
} = recommendationCardSlice.actions;
export default recommendationCardSlice.reducer;